const Residencial= () => {
    return <h1>Residencial</h1>;
  };
  
  export default Residencial;